import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    $('#datepicker_start').datetimepicker({
      icons: {
        time: "far fa-clock",
        date: "fa fa-calendar",
        up: "fa fa-arrow-up",
        down: "fa fa-arrow-down"
      },
      format: 'L'
    });
    
    $('#datepicker_end').datetimepicker({
      icons: {
        time: "far fa-clock",
        date: "fa fa-calendar",
        up: "fa fa-arrow-up",
        down: "fa fa-arrow-down"
      },
      format: 'L',
      useCurrent: false
    });
  }
}